var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDuplicateControlSet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 13.5V5.084C1 4.2569 1.6729 3.584 2.5 3.584H3.5796V2.5C3.5796 1.6729 4.2529 1 5.0801 1H13.4995C14.3266 1 15 1.6729 15 2.5V10.916C15 11.7431 14.3267 12.416 13.4995 12.416H12.4199V13.5C12.4199 14.3271 11.747 15 10.9199 15H2.5C1.6728 15 1 14.3272 1 13.5ZM13.4995 11.416C13.7754 11.416 14 11.1914 14 10.916V2.5C14 2.2246 13.7754 2 13.4995 2H5.0801C4.8042 2 4.5796 2.2246 4.5796 2.5V3.584H10.9199C11.747 3.584 12.4199 4.2569 12.4199 5.084V11.416H13.4995ZM10.9199 14C11.1958 14 11.4199 13.7754 11.4199 13.5V5.084C11.4199 4.8086 11.1958 4.584 10.9199 4.584H2.5C2.2241 4.584 2 4.8086 2 5.084V13.5C2 13.7754 2.2241 14 2.5 14H10.9199Z",
    fill: "#606060"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20312 8.77979H7.20312V6.77979H6.20312V8.77979H4.20312V9.77979H6.20312V11.7798H7.20312V9.77979H9.20312V8.77979Z",
    fill: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateControlSet);
export default __webpack_public_path__ + "static/media/DuplicateControlSet.fbb6b4d1545ad21820d95743d856027b.svg";
export { ForwardRef as ReactComponent };